export default (that) => [
  {
    field: 'seq',
    width: 50,
    align: 'center',
    fixed: 'left',
    type: 'seq',
  },
  {
    title: that.$l('table_label_ftyInv') || '国内库存',
    field: 'ftyInv',
    width: 100,
    align: 'center',
    showHeaderOverflow: true,
  },
  {
    title:
      that.$l('table_label_ftyInvDaysAvailableLocal') || '国内库存可售天数',
    field: 'ftyInvDaysAvailableLocal',
    minWidth: 140,
    align: 'center',
    showHeaderOverflow: true,
  },
  {
    title: that.$l('table_label_amzMarketName') || '市场',
    field: 'amzMarketName',
    minWidth: 100,
    align: 'center',
    showHeaderOverflow: true,
    slots: { default: 'amzMarketName' },
  },
  {
    title: that.$l('table_label_dailySales') || '日销',
    field: 'dailySales',
    width: 120,
    align: 'center',
    showHeaderOverflow: true,
  },
  {
    title: that.$l('table_label_fbaInv') || 'FBA库存',
    field: 'fbaInv',
    width: 120,
    align: 'center',
    showHeaderOverflow: true,
  },
  {
    title: that.$l('table_label_ftyInvDaysAvailable') || 'FBA可售天数',
    field: 'ftyInvDaysAvailable',
    width: 130,
    align: 'center',
    showHeaderOverflow: true,
  },
  {
    title: that.$l('table_label_fbaSafetyStockDays') || 'FBA安全库存天数',
    field: 'fbaSafetyStockDays',
    width: 150,
    align: 'center',
    showHeaderOverflow: true,
  },
]
